import {useTranslation as useReactI18nextTranslation} from "next-i18next";

export function useTranslation() {
  const {t} = useReactI18nextTranslation();

  return t;
}
